export default "__VITE_ASSET__3604f85d__"